module.exports = __webpack_public_path__ + "static/media/filters-grey.11a8ae56.svg";